export default __webpack_public_path__ + "static/media/Logistique.8202b9b9.jpg";